import { isMsx } from './utils-msx';

export const isStandalone = () => !isMsx();
